"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarRating = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var IconStar_1 = require("../icon/IconStar");
var IconStarOutline_1 = require("../icon/IconStarOutline");
var Wrapper = function (props) {
    if (props.onClick) {
        return (React.createElement("button", { className: (0, classnames_1.default)('br-transform', 'hover:br-scale-105'), onClick: props.onClick }, props.children));
    }
    return React.createElement(React.Fragment, null, props.children);
};
var bcns = (0, classnames_1.default)('br-text-yellow-600', 'br-w-8', 'br-h-8');
var StarRating = function (props) {
    return (React.createElement("div", { className: (0, classnames_1.default)('br-flex') }, [1, 2, 3, 4, 5].map(function (num) {
        // Get diff between current value and actual star rating
        var delta = props.rating - num + 1;
        // Set up the onClick handler (if provided)
        var onClick = props.onChange ? function () { return props.onChange(num); } : undefined;
        // Full star
        if (delta >= 1) {
            return (React.createElement(Wrapper, { key: num, onClick: onClick },
                React.createElement(IconStar_1.IconStar, { className: bcns })));
        }
        // Outlined star
        if (delta < 0) {
            return (React.createElement(Wrapper, { key: num, onClick: onClick },
                React.createElement(IconStarOutline_1.IconStarOutline, { className: bcns })));
        }
        // Fractional star
        return (React.createElement(Wrapper, { key: num, onClick: onClick },
            React.createElement("div", { className: (0, classnames_1.default)(bcns, 'br-relative') },
                React.createElement(IconStarOutline_1.IconStarOutline, { className: (0, classnames_1.default)(bcns, 'br-absolute') }),
                React.createElement("span", { style: { width: "".concat(delta * 100, "%") }, className: (0, classnames_1.default)('br-h-8', 'br-absolute', 'br-overflow-hidden', 'br-mx-auto') },
                    React.createElement(IconStar_1.IconStar, { className: (0, classnames_1.default)(bcns) })))));
    })));
};
exports.StarRating = StarRating;
